import { useEffect, useState } from 'react'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as urlValue from '../oldReportsUrls'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import { appendToUrl, focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import {
  goodBalanceReportViewData,
  reportOption,
  GoodBalReprtPayType,
  shortFilterData,
  PDFHeaderColumns,
  FilterHeader,
  summaryHeader,
} from './constants'
import { updateAlertError } from '../../../../store/common/common_action'
import { getGoodBalDropData } from '../../../../store/reports/reports_action'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { urls } from '../../../common/constants'
import { GetRequest } from '../../../common/api'

const GoodBalance = () => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state)
  const { common, reports } = state
  const { loginData, roleRights, companySettings } = common
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD
  const loginCountryId = companySettings[0]?.DefaultCurrencyID
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
  const { goodBalDropData } = reports

  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selSelectedCity, setSelSelectedCity] = useState('')
  const [selectedCityData, setSelectedCityData] = useState([])
  const [selSelectedBranch, setSelSelectedBranch] = useState('')
  const [selectedBranchData, setSelectedBranchData] = useState([])
  const [selectedAllBranchData, setSelectedAllBranchData] = useState([])
  // const [selDestinationCity, setSelDestinationCity] = useState("")
  // const [destinationCityData, setDestinationCityData] = useState([])
  // const [selDestinationBranch, setSelDestinationBranch] = useState("")
  // const [destinationBranchData, setDestinationBranchData] = useState([])
  const [paymentType, setPaymentType] = useState(GoodBalReprtPayType?.[0])
  const [reportView, setReportView] = useState(goodBalanceReportViewData?.[0])
  const [reportOptions, setReportOptions] = useState(reportOption?.[0])
  const [showTable, setShowTable] = useState(false)
  const [user, setUser] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [selShortFilter, setSelShortFilter] = useState(shortFilterData?.[0])
  const reportName = 'Goods Balance'
  const setAlert = useSetAtom(alertAtom)
  const setLoader = useSetAtom(globalLoaderAtom)
  const headerData = {
    // company: loginData.strCompanyName,
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    selSelectedCity: selSelectedCity?.City,
    selSelectedBranch: selSelectedBranch?.Branch,
    paymentType: paymentType?.name,
    reportView: reportView?.view,
    reportOptions: reportOptions?.Option,
    dataType: 'entry',
  }
  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      // setUser(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
      setUser(
        !(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin)
      )
      setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
    }
  }, [roleRights, loginData])
  useEffect(() => {
    if (!isEmpty(goodBalDropData)) {
      if (goodBalDropData?.Data?.Table?.length > 0) {
        let data = []
        let data1 = []
        goodBalDropData?.Data?.Table?.map((val, i) => {
          data.push({ City: val?.City, CityID: val?.CityID })
          data1.push({ Branch: val?.Branch, BranchID: val?.BranchID, CityID: val.CityID })
        })
        setSelectedCityData([{ City: 'All Cities', CityID: 0 }, ...data])
        setSelectedBranchData([{ Branch: 'All Branches', BranchID: 0 }, ...data1])
        setSelectedAllBranchData([{ Branch: 'All Branches', BranchID: 0 }, ...data1])
        setSelSelectedCity({ City: 'All Cities', CityID: 0 })
        setSelSelectedBranch({ Branch: 'All Branches', BranchID: 0 })
        if (user) {
          setSelSelectedCity({ City: loginData?.strCityName, CityID: loginData?.intBranchCityID })
          setSelSelectedBranch({ Branch: loginData?.strBranchName, BranchID: loginData?.intBranchID })
        } else {
          const selectedCity = data?.filter((val) => val.CityID === loginData?.intBranchCityID)
          const selectedBranch = data1?.filter((val) => val.BranchID === loginData?.intBranchID)
          if (selectedCity?.length > 0) {
            setSelSelectedCity(selectedCity?.[0])
          } else {
            setSelSelectedCity({ City: 'All Cities', CityID: 0 })
          }
          if (selectedBranch?.length > 0) {
            setSelSelectedBranch(selectedBranch?.[0])
          } else {
            setSelSelectedBranch({ Branch: 'All Branches', BranchID: 0 })
          }
        }
      } else {
        setSelectedCityData([])
        setSelectedBranchData([])
        setSelectedAllBranchData([])
        setSelSelectedCity(' ')
        setSelSelectedBranch(' ')
      }
    }
  }, [goodBalDropData])

  const filterData = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
    } else {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        BranchID: loginData?.intBranchID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
        UserID: loginData.intUserID,
      }
      dispatch(getGoodBalDropData(obj))
    }
  }

  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    if (goodBalDropData?.Data?.Table?.length > 0) {
      if (user) {
        setSelSelectedCity(' ')
        setSelSelectedBranch(' ')
      } else {
        setSelSelectedCity(selectedCityData?.[0])
        setSelSelectedBranch(selectedBranchData?.[0])
      }
    } else {
      setSelSelectedCity('')
      setSelSelectedBranch('')
    }
    setPaymentType(GoodBalReprtPayType?.[0])
    setReportView(goodBalanceReportViewData?.[0])
    setReportOptions(reportOption?.[0])
    setShowTable(false)
  }

  const selectedSourceCity = (obj) => {
    setSelSelectedCity(obj)
    setShowTable(false)
    if (obj?.CityID === 0) {
      setSelectedBranchData(
        removeDuplicatesFromArray(selectedAllBranchData, 'BranchID').filter(
          (val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val.BranchID === 0
        )
      )
      setSelSelectedBranch(
        removeDuplicatesFromArray(selectedAllBranchData, 'BranchID').filter(
          (val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val.BranchID === 0
        )?.[0]
      )
    } else {
      setSelectedBranchData(removeDuplicatesFromArray(selectedAllBranchData, 'BranchID').filter((val) => val.CityID === obj?.CityID))
      setSelSelectedBranch(removeDuplicatesFromArray(selectedAllBranchData, 'BranchID').filter((val) => val.CityID === obj?.CityID)?.[0])
    }
  }

  // const handleClick1 = () => {
  //     if (selSelectedCity == "" || selSelectedCity == ' ') {
  //         dispatch(updateAlertError({ show: true, msg: 'Select  City', nextId: '' }))
  //     } else if (selSelectedBranch == "" || selSelectedBranch == ' ') {
  //         dispatch(updateAlertError({ show: true, msg: 'Select  Branch', nextId: '' }))
  //     } else if (Math.abs(toDate.diff(fromDate, 'days'))>31) {
  //         dispatch(updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' }))
  //     } else if (goodBalDropData?.Data?.Table?.length > 0) {
  //         const body = {
  //             CompanyID: loginData?.intCompanyID,
  //             CityID: selSelectedCity?.CityID,
  //             BranchID: selSelectedBranch?.BranchID,
  //             UserID: loginData?.intUserID,
  //             FromDate: moment(fromDate).format("YYYY-MM-DD"),
  //             ToDate: moment(toDate).format("YYYY-MM-DD"),
  //             ConsignmentSubTypeID: 0,
  //             PaymentType: paymentType?.typeId,
  //             AllowViewAllReport: (roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 1 || loginData?.IsBranchAdmin == 1 || loginData?.IsMTPLAdmin == 1 || loginData?.IsAdmin == 1) ? 1 : 0,
  //             Mode: reportOptions?.optionId,
  //             ReportSort:selShortFilter?.id
  //         }
  //         dispatch(getGoodBalTableData(body))
  //         setShowTable(true)
  //     } else {
  //         dispatch(updateAlertError({ show: true, msg: 'No Data Found For Selected Date Range', nextId: '' }))
  //     }
  // }
  const detailFormateData = (array) => {
    let totals = {
      Items: 0,
      Freight: 0,
      Cartage: 0,
      Hamali: 0,
      Valuation: 0,
      OtherCharges: 0,
      BookingGST: 0,
      NetAmount: 0,
    }

    const data = array.map((item, i) => {
      // accumulate totals safely
      totals.Items += item.Items || 0
      totals.Freight += item.Freight || 0
      totals.Cartage += item.Cartage || 0
      totals.Hamali += item.Hamali || 0
      totals.Valuation += item.Valuation || 0
      totals.OtherCharges += item.OtherCharges || 0
      totals.BookingGST += item.BookingGST || 0
      totals.NetAmount += item.NetAmount || 0

      return {
        ...item,
        SN: i + 1,
        'LRNO^^BookingDate': `${item.LRNO}\n${item.BookingDate}`,
        'SourceCity^^SourceBranch': `${item.SourceCity}\n${item.SourceBranch || ''}`,
        'DestinationCity^^DestinationBranch': `${item.DestinationCity}\n${item.DestinationBranch || ''}`,
        'Sender^^RecName': `${item.Sender}\n${item.RecName}`,
      }
    })

    data.push({
      PaymentType: `Total: ${headerData?.reportOptions}`,
      ...totals,
      isTotal: true,
      dataType: 'total',
      colSpan: 2,
    })

    return data
  }
  const isDelivery = reportOptions?.optionId === 0
  const updatedSummaryHeader = summaryHeader
    .map((val) => ({ ...val, align: val.xlCol?.dataType === 'quantity' ? 'right' : 'left' }))
    .map((item) => {
      if (item.field === 'DestinationCity') {
        return {
          ...item,
          header: isDelivery ? 'Source\nCity' : 'Destination\nCity',
          exportHead: isDelivery ? 'Source\nCity' : 'Destination\nCity',
          field: isDelivery ? 'SourceCity' : 'DestinationCity',
        }
      }
      return item
    })
  let headers = []
  if (reportView.id === 1) {
    headers = updatedSummaryHeader.map((col) => ({
      ...col,
      align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
      exportHead: col.header,
      dataType: 'header',
    }))
  } else {
    headers = PDFHeaderColumns.map((col) => ({
      ...col,
      align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
      exportHead: col.header,
      dataType: 'header',
    }))
  }

  const handleClick1 = () => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = selSelectedCity?.CityID === 0 || selSelectedBranch?.BranchID === 0
    if (isAllSelected && diffDays > 15) {
      setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
      return
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    }
    if (selSelectedCity == '' || selSelectedCity == ' ') {
      setAlert({ show: true, msg: 'Please Select  City', nextId: '' })
      return
    }
    if (selSelectedBranch == '' || selSelectedBranch == ' ') {
      setAlert({ show: true, msg: 'Please Select  Branch', nextId: '' })
      return
    }
    setLoader(true)
    const body = {
      CompanyID: loginData?.intCompanyID,
      CityID: selSelectedCity?.CityID,
      BranchID: selSelectedBranch?.BranchID,
      UserID: loginData?.intUserID,
      FromDate: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      ConsignmentSubTypeID: 0,
      PaymentType: paymentType?.typeId,
      AllowViewAllReport:
        roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 1 ||
          loginData?.IsBranchAdmin == 1 ||
          loginData?.IsMTPLAdmin == 1 ||
          loginData?.IsAdmin == 1
          ? 1
          : 0,
      Mode: reportOptions?.optionId,
      ReportSort: selShortFilter?.id,
    }
    GetRequest(urls.getGoodBalTableData, body)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const updatedData = res?.Data?.Table?.map((item) => ({ ...item, dataType: 'entry' }))
        const data = detailFormateData(updatedData)
        const makeSummary = (data, groupKey) => {
          const branchMap = {}
          data.forEach((row) => {
            const branch = row.SourceBranch
            if (!branchMap[branch]) branchMap[branch] = {}
            const city = row[groupKey]
            if (!branchMap[branch][city]) {
              branchMap[branch][city] = {
                cityName: city,

                PaidUnit: 0,
                PaidAmount: 0,

                ToPayUnit: 0,
                ToPayAmount: 0,

                OnAccountUnit: 0,
                OnAccountAmount: 0,

                TotalUnit: 0,
                TotalAmount: 0,
              }
            }
            const rec = branchMap[branch][city]
            const items = Number(row.Items) || 0
            const amount = Number(row.NetAmount) || 0
            const type = Number(row.PaymentTypeID)
            if (type === 1) {
              rec.PaidUnit += items
              rec.PaidAmount += amount
            } else if (type === 2) {
              rec.ToPayUnit += items
              rec.ToPayAmount += amount
            } else if (type === 5) {
              rec.OnAccountUnit += items
              rec.OnAccountAmount += amount
            }
            rec.TotalUnit += items
            rec.TotalAmount += amount
          })
          return Object.entries(branchMap).map(([branch, cities]) => {
            const rows = Object.values(cities).map((r, i) => ({
              SN: i + 1,
              ...r,
            }))
            const total = rows.reduce(
              (t, r) => ({
                PaidUnit: t.PaidUnit + r.PaidUnit,
                PaidAmount: t.PaidAmount + r.PaidAmount,

                ToPayUnit: t.ToPayUnit + r.ToPayUnit,
                ToPayAmount: t.ToPayAmount + r.ToPayAmount,

                OnAccountUnit: t.OnAccountUnit + r.OnAccountUnit,
                OnAccountAmount: t.OnAccountAmount + r.OnAccountAmount,

                TotalUnit: t.TotalUnit + r.TotalUnit,
                TotalAmount: t.TotalAmount + r.TotalAmount,
              }),
              {
                PaidUnit: 0,
                PaidAmount: 0,
                ToPayUnit: 0,
                ToPayAmount: 0,
                OnAccountUnit: 0,
                OnAccountAmount: 0,
                TotalUnit: 0,
                TotalAmount: 0,
              }
            )

            return { branch, rows, total }
          })
        }
        const buildTableRows = (summary, cityFieldName, totalLabel) => {
          const rows = []
          summary.forEach((branch) => {
            rows.push({
              dataType: 'header',
              SN: `Branch: ${branch.branch}`,
              colSpan: { SN: updatedSummaryHeader.length },
              align: 'left'
            })
            branch.rows.forEach((r) => {
              rows.push({
                dataType: 'entry',
                SN: r.SN,
                [cityFieldName]: r.cityName,
                PaidUnit: r.PaidUnit,
                PaidAmount: r.PaidAmount,
                ToPayUnit: r.ToPayUnit,
                ToPayAmount: r.ToPayAmount,
                OnAccountUnit: r.OnAccountUnit,
                OnAccountAmount: r.OnAccountAmount,
                TotalUnit: r.TotalUnit,
                TotalAmount: r.TotalAmount,
              })
            })
            rows.push({
              dataType: 'total',
              SN: totalLabel,
              colSpan: { SN: updatedSummaryHeader.findIndex((h) => h.field === 'PaidUnit') },

              PaidUnit: branch.total.PaidUnit,
              PaidAmount: branch.total.PaidAmount,

              ToPayUnit: branch.total.ToPayUnit,
              ToPayAmount: branch.total.ToPayAmount,

              OnAccountUnit: branch.total.OnAccountUnit,
              OnAccountAmount: branch.total.OnAccountAmount,

              TotalUnit: branch.total.TotalUnit,
              TotalAmount: branch.total.TotalAmount,
            })
          })
          return rows
        }
        const summary = makeSummary(updatedData, isDelivery ? 'SourceCity' : 'DestinationCity')
        const finalTableData = buildTableRows(
          summary,
          isDelivery ? 'SourceCity' : 'DestinationCity',
          isDelivery ? 'Total: Delivery Goods Balance' : 'Total: Booking Goods Balance'
        )
        const reportPayload = {
          reportName,
          criteriaHeaders: FilterHeader,
          criteriaData: [headerData],
          tableData: reportView.id === 1 ? finalTableData : data,
          mainHeader: headers,
          isShowManageColumn: false,
          manageColumnID: '',
          hideHeader: false,
          showColumnBorders: true,
          serialNokey :'SN'
        }

        const rid = Date.now().toString()

        if (!window.generatedReports) {
          window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload

        window.open(`/view-report?rid=${rid}`, '_blank')
        // setTableData(data)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }

  const handleClick2 = () => {
    if (selSelectedCity == '' || selSelectedCity == ' ') {
      dispatch(updateAlertError({ show: true, msg: 'Select  City', nextId: '' }))
    } else if (selSelectedBranch == '' || selSelectedBranch == ' ') {
      dispatch(updateAlertError({ show: true, msg: 'Select  Branch', nextId: '' }))
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      dispatch(updateAlertError({ show: true, msg: 'Select More Then One Month', nextId: '' }))
    } else {
      let url = urls.goodsBalanceReport
      const urlData = urlValue.goodsBalanceReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.intBranchID = selSelectedBranch?.BranchID || 0
      urlData.fromdate = fromDate.format('DD-MMM-YYYY')
      urlData.todate = toDate.format('DD-MMM-YYYY')
      urlData.intpaymentType = paymentType?.typeId || 0
      urlData.Mode = reportOptions?.optionId
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  const paymentDropdownData = (GoodBalReprtPayType || [])
    .filter((val) => roleRights?.Table?.find((item) => item.BookingRightsID === 1)?.[val.uniqKey] === 1 || val.uniqKey === 'All')
    .map((item) => {
      if (UseToPayAsCOD === 1) {
        switch (item.typeId) {
          case 2:
            return { ...item, name: 'COD' }
          case 7:
            return { ...item, name: 'COD Manual' }
          case 9:
            return { ...item, name: 'COD DDDV' }
          case 4:
            return null
          default:
            return item
        }
      }
      return item
    })
    .filter(Boolean)
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.selectCompnay}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              // onSelect={(val) => { setSelCompany(val); setShowTable(false) }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              variant="contained"
              disabled={true}
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={id.goButton}
              className="btn btn-primary"
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '120px' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Date'}
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt(id.toDate)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '120px' }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Date'}
              value={toDate}
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt('goodGoBtn')
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button
              id="goodGoBtn"
              onKeyDown={(e) => navigation3(e, id.gbSourceCity, id.toDate, () => filterData())}
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={filterData}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} style={{ width: '230px' }}>
            <DropDownOA
              id={id.gbSourceCity}
              label={'Select City'}
              searchPlaceholder={`Search Selected City`}
              defaultvalue={selSelectedCity?.City || selSelectedCity}
              data={removeDuplicatesFromArray(selectedCityData, 'CityID') || []}
              listWidth="230px"
              dataKey={`City`}
              idKey={`CityID`}
              disabled={user}
              // onSelect={(obj) => { setSelSelectedCity(obj); setShowTable(false) }}
              onSelect={(obj) => selectedSourceCity(obj)}
              nextId={id.gbSourceBranch}
              prevId={'goodGoBtn'}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '230px' }}>
            <DropDownOA
              id={id.gbSourceBranch}
              label={'Select Branch'}
              searchPlaceholder={`Search Selected Branch`}
              defaultvalue={selSelectedBranch?.Branch || selSelectedBranch}
              data={
                removeDuplicatesFromArray(selectedBranchData, 'BranchID').filter(
                  (val) => val.CityID === selSelectedCity?.CityID || selSelectedCity?.CityID === 0 || val.BranchID === 0
                ) || []
              }
              listWidth="230px"
              dataKey={`Branch`}
              idKey={`BranchID`}
              disabled={user && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
              onSelect={(obj) => {
                setSelSelectedBranch(obj)
                setShowTable(false)
              }}
              nextId={id.gbPaymentType}
              prevId={id.gbSourceCity}
              width="100%"
            />
          </Item>
        </Box>
        <Box sx={{ ...sx.reportFlex }}>
          <Item sx={sx.itemsx} style={{ width: '205px' }}>
            <DropDownOA
              id={id.gbPaymentType}
              data={paymentDropdownData || []}
              defaultvalue={paymentType?.name}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`typeId`}
              onSelect={(value) => {
                setPaymentType(value)
                setShowTable(false)
              }}
              nextId={id.gbView}
              prevId={id.gbSourceBranch}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '205px' }}>
            <DropDownOA
              id={id.gbView}
              defaultvalue={reportView?.view}
              data={goodBalanceReportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => setReportView(value)}
              nextId={id.anReportOptions}
              prevId={id.gbPaymentType}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '235px' }}>
            <DropDownOA
              id={id.anReportOptions}
              data={reportOption || []}
              defaultvalue={reportOptions?.Option || ''}
              width="100%"
              searchPlaceholder={`Search By Report Options`}
              label={'Report Options'}
              tabIndex="2"
              dataKey={`Option`}
              idKey={`optionId`}
              listWidth="200px"
              onSelect={(value) => {
                setReportOptions(value)
                setShowTable(false)
              }}
              nextId={id.reportmainButton}
              prevId={id.gbView}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '235px' }}>
            <DropDownOA
              id={'sortFilter'}
              data={shortFilterData || []}
              defaultvalue={selShortFilter?.name || ''}
              width="100%"
              searchPlaceholder={`Search By Report Sort`}
              label={'Report Sort By'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`id`}
              listWidth="200px"
              onSelect={(value) => {
                setSelShortFilter(value)
                setShowTable(false)
              }}
            // nextId={id.reportmainButton}
            // prevId={id.gbView}
            />
          </Item>

          <Item
            sx={sx.itemsx}
            style={{ cursor: 'pointer' }}
            onKeyDown={(e) =>
              navigation3(e, showTable ? (disableExcel ? 'ExportToPdf' : 'ExportToExl') : id.fromDate, id.anReportOptions, () =>
                handleClick1()
              )
            }
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              id1={id.reportmainButton}
              prevID={id.summaryCheck}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
            <RefreshSvg width={'24px'} height={'24px'} />
          </Item>
        </Box>
      </Item>
      {/* <Item>
        {showTable &&
          !loader &&
          (reportView?.id === 0 ? (
            <DetailTable
              UseToPayAsCOD={UseToPayAsCOD}
              loginCountryId={loginCountryId}
              disableExcel={disableExcel}
              headerData={headerData}
              tableData={goodBalTableData?.Data?.Table || []}
              UseFormattedLRinReports={UseFormattedLRinReports}
            />
          ) : reportView?.id === 1 ? (
            <SummaryTable
              tableData={goodBalTableData?.Data?.Table || []}
              headerData={headerData}
              reportName={reportName}
              reportOptions={reportOptions}
            />
          ) : null)}
      </Item> */}
    </>
  )
}

export default GoodBalance
